import { ActionPanel as Component } from './action-panel';
import { Label, Divider, Action } from './components';
import { ConfirmationPopover } from './confirmation-popover';
import { Popover } from './popover';
import { PopoverAction, usePopoverActionRef } from './popover-action';

type ActionPanel = typeof Component & {
  Divider: typeof Divider;
  Action: typeof Action;
  Label: typeof Label;
  PopoverAction: typeof PopoverAction;
  Popover: typeof Popover;
  ConfirmationPopover: typeof ConfirmationPopover;
};

const ActionPanel: ActionPanel = Component as unknown as ActionPanel;

ActionPanel.Divider = Divider;
ActionPanel.Action = Action;
ActionPanel.Label = Label;
ActionPanel.PopoverAction = PopoverAction;
ActionPanel.Popover = Popover;
ActionPanel.ConfirmationPopover = ConfirmationPopover;

export { ActionPanel, usePopoverActionRef };
